export enum StoriesStrategy {
  similarItems = 'similar_items',
  shopTheLook = 'shop_the_look',
  personalization = 'personalization',
  socialContent = 'social_content',
  frequentlyBoughtTogether = 'frequently_bought_together',
}
